import React, { useEffect, useRef, useState } from 'react';
import classes from './SplashScreen.module.css';
import world1 from '../../assets/earth/world1.png';
import world2 from '../../assets/earth/world2.png';
import world3 from '../../assets/earth/world3.png';
import world4 from '../../assets/earth/world4.png';
import world5 from '../../assets/earth/world5.png';

const worlds = [world1, world2, world3, world4, world5];

const SplashScreen = ({ onContinue }) => {
  const [fontsReady, setFontsReady] = useState(false);
  const [worldIndex, setWorldIndex] = useState(0);
  const doneRef = useRef(false);

  useEffect(() => {
    document.fonts.ready.then(() => setFontsReady(true));
  }, []);

  const advance = () => {
    if (doneRef.current) return;
    doneRef.current = true;
    onContinue && onContinue();
  };

  useEffect(() => {
    let timeoutId;

    if (!fontsReady) return;

    const step = (index) => {
      setWorldIndex(index);

      const isLast = index === worlds.length - 1;
      const delay = isLast ? 800 : 400;

      timeoutId = setTimeout(() => {
        if (isLast) {
          advance();
        } else {
          step(index + 1);
        }
      }, delay);
    };

    // Start at frame 0 (already showing), schedule transition to frame 1
    timeoutId = setTimeout(() => step(1), 400);

    return () => clearTimeout(timeoutId);
  }, [fontsReady]);

  if (!fontsReady) return null;

  return (
    <div className={classes.container} onClick={advance}>
      <div className={classes.content}>
        <h1 className={classes.title}>CAMPING<br />BUDDY</h1>
        <div className={classes.globe}>
          <img
            src={worlds[worldIndex]}
            alt="Camping Buddy Globe"
            className={classes.globeImage}
          />
        </div>
        <p className={classes.tagline}>Less Mess, More Party</p>
      </div>
    </div>
  );
};

export default SplashScreen;
